const sentryEnabledFromEnv = process.env.SENTRY_ENABLED

export default async ({ app, router }) => {
  if (!sentryEnabledFromEnv) {
    console.log('Sentry was disabled - skipping setup')
    return
  }

  const Sentry = await import(/* webpackChunkName: "sentry" */ '@sentry/vue')

  Sentry.init({
    app,
    dsn: 'https://24f74065604e4846a9e9681f7d541dae@error-tracking.cloud.wanyplace.de/6759692',
    // Ab v11 sammelt Sentry standardmäßig mehr Daten; diese Werte entsprechen dem Stand von v10
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] }
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      graphQL: { document: false, variables: false },
      frameContextLines: 7
    },
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications'
    ],
    release: '__release__',
    environment: '__environment__'
  })

  Sentry.setTag('tenant', '__tenantId__')
  Sentry.setTag('brand', '__brandId__')
  Sentry.setTag('resourceId', '__resourceId__')
  Sentry.setTag('app', 'pmr')
}
